import React, { useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { Create, FileCopySharp } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';
import moment from 'moment';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsFindBy, wsPost } from 'services/WService.js';

//modal
import Modal from './Modal';
import Modal2 from './ModalUpdate';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { wsUpdate } from 'services/WService';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Periodo', accessor: 'periodo', width: 130 },
  { Header: 'Código Vendedor', accessor: 'SlpCode', width: 170 },
  { Header: 'Nombre Vendedor', accessor: 'SlpName' },
  { Header: 'Mesa', accessor: 'mesa' },
  { Header: 'Canal', accessor: 'canal' },
  { Header: 'Cuota sin IGV', accessor: 'cuota_sin_igv' },
  { Header: 'Cuota Total Cremas', accessor: 'cuota_total' },
  { Header: 'Cuota mensual al 55%', accessor: 'cuota_month_percent' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function Colgate(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal();
  const [model2, setOpen2] = useModal();
  const [notify, showNotify] = useToasty();
  const [cuotasIncentivos, setCuotasIncentivos] = useState([]);
  const [valueSearch, setValueSearch] = useState({});
  const [currentPeriod, setCurrentPeriod] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);

  const handleChange = (id, field, value) => {
    const index = cuotasIncentivos.findIndex((item) => item.id == id);
    cuotasIncentivos[index][field] = value;
    setCuotasIncentivos([...cuotasIncentivos]);
  };
  
  async function loadCuotasIncentivos(filter) {
    setDataLoading(true);
    let response = await wsFindBy('sale/cuotas-incentivos', filter);
    setDataLoading(false);
    if (response.success) {
      setCuotasIncentivos(response.data);
    }
  }
  
  async function updateCuotas(id, field, value) {
    setDataLoading(true);
    let response = await wsUpdate('sale/cuotas-incentivos', id, { [field]: value });
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      console.log('Datos devueltos: ', response.data);
      loadCuotasIncentivos(valueSearch);
    } else {
      showNotify(response.message, 'error');
      loadCuotasIncentivos(valueSearch);
    }
  }
  
  async function transferirRegistros(sourceperiodo, targetperiodo) {
    setDataLoading(true);
    let response = await wsPost('sale/cuotas-incentivos/transferirRegistros', {
      SourcePeriodo: sourceperiodo,
      TargetPeriodo: targetperiodo,
    });
    setDataLoading(false);

    if (response.success) {
      showNotify(response.message);
      console.log('Transferencia exitosa: ', response.data);
      loadCuotasIncentivos(valueSearch);
    } else {
      showNotify(response.message, 'error');
      console.error('Error al transferir registros: ', response);
    }
  }

  const handleFilterChange = (value) => {
    const period = parseInt(moment(value.periodo).format('YYYYMM'), 10);
    setCurrentPeriod(period);
  };

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={() => loadCuotasIncentivos(valueSearch)}
        />
      ) : undefined}
      {model2.open ? (
        <Modal2 
          model={model2}
          setOpen={setOpen2}
          showNotify={showNotify}
          reload={() => loadCuotasIncentivos(valueSearch)}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_STORE}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Cuotas de colgate {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <FilterCustom
              getFilter={loadCuotasIncentivos}
              getValueSearch={(value) => {
                setValueSearch(value);
                handleFilterChange(value);
              }}
              date
              dateType="month"
              labelDate="periodo"
              dateField="periodo"
              allSeller
            />
            <Button
              color="danger"
              onClick={() => {
                const sourcePeriod = moment(currentPeriod.toString(), "YYYYMM").subtract(1, "month").format("YYYYMM");
                transferirRegistros(Number(sourcePeriod), currentPeriod);
              }}>
              Inicializar cuotas de colgate
            </Button>
            <ReactTable
              excelName="cuotas_de_incentivos"
              formatDate="DD-MM-YYYY"
              defaultWidth={1300}
              columns={columns}
              data={cuotasIncentivos.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => setOpen2(item)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard
                        permission={ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_DELETED}
                      >
                        <ButtonDelete
                          entity="sale/cuotas-incentivos"
                          id={item.id}
                          
                          reload={() => {
                            setDataLoading(true);
                            loadCuotasIncentivos(valueSearch).then(() => setDataLoading(false));
                        }}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  periodo: item.periodo,
                  SlpCode: item.SlpCode,
                  SlpName: item.SlpName,
                  mesa: item.mesa,
                  canal: item.canal,
                  cuota_sin_igv: item.cuota_sin_igv,
                  cuota_total: item.cuota_total,
                  cuota_month_percent: item.cuota_month_percent,
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
